<script lang="ts">
import type { InputTagsProps } from '@nuxt/ui';
import type { InputBlockProps } from '~/types/input-block';

interface InputTagsBlockProps extends
	InputBlockProps,
	Pick<InputTagsProps, 'size' | 'variant' | 'color' | 'placeholder'> {
}

const __DsBlock = {
	type: 'input',
	name: '$t:blocks.input_tags.name',
	description: '$t:blocks.input_tags.description',
	icon: 'lucide:tags',
	category: 'input',
	tags: ['form-control'],
	options: [
		{
			name: 'modelValue',
			model: true,
		},
		{
			name: 'placeholder',
		},
		{
			name: 'size',
			type: 'enum',
			values: BLOCK_CONTROL_SIZE_OPTIONS,
		},
		{
			name: 'variant',
			type: 'enum',
			values: BLOCK_INPUT_VARIANT_OPTIONS,
		},
		{
			name: 'color',
			type: 'enum',
			values: BLOCK_COLOR_OPTIONS,
		},
		{
			name: 'readonly',
		},
	],
}</script>

<script setup lang="ts">
import { reactivePick } from '@vueuse/core';
import { defineBlock } from '#layers/block-engine';
import { BLOCK_COLOR_OPTIONS, BLOCK_CONTROL_SIZE_OPTIONS, BLOCK_INPUT_VARIANT_OPTIONS } from '#layers/blocks/constants/ui-options';
import { useDisabledNotice } from '#layers/ui';
import { usePrimitiveFormField } from '~/composables/form-block/use-primitive-form-field';

const props = defineProps<InputTagsBlockProps>();
const model = defineModel<string[]>();

;

const { modelValue, disabled, disabledNotice } = usePrimitiveFormField(props, { model, defaultValue: () => [] });
const { showDisabledNotice } = useDisabledNotice({ disabled, disabledNotice });
const forwarded = reactivePick(props, 'size', 'variant', 'color', 'placeholder', 'readonly');
</script>

<template>
	<DTooltip :delay-duration="0" :disabled="!showDisabledNotice" :text="disabledNotice">
		<DInputTags v-bind="forwarded" v-model="modelValue" :disabled :readonly :aria-readonly="readonly">
			<template #item-delete>
				<DIcon v-if="!readonly" name="lucide:x" />
				<!-- The empty <div> is necessary because NuxtUI renders a close icon if this slot renders empty -->
				<div v-else />
			</template>
		</DInputTags>
	</DTooltip>
</template>
